import React, { useEffect, useState } from "react";
import Form from "./Form";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEntityCrud } from "../../hooks/useEntityCrud";
import moment from "moment-jalali";

const initialValues = {
  person: {},
  title: "",
  iban: "",
  address: "",
  phone: "",
  guildId: "",
  subGuildId: "",
  website: "",
  telegram: "",
  instagram: "",
  photo1: "",
  photo2: "",
  photo3: "",
  photo4: "",
  photo5: "",
  photo6: "",
  provinceId: 0,
  cityId: 0,
  supportPhones: '',
  terminals: [
    {
      terminalNo: "",
      acceptorId: "",
      serialNo: "",
    },
  ],
  works: [
    {
      dayId: 1,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 2,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 3,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 4,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 5,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 6,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 7,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 1,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 2,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 3,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 4,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 5,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 6,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
    {
      dayId: 7,
      openTime: "",
      closeTime: "",
      businessId: 0,
    },
  ],
};

const validationSchema = Yup.object({
  person: Yup.object({
    name: Yup.string().required()
}),
  ip11: Yup.string()
    .test('ip11', ' ', value => {

      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && value.replace(' ', '') &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip12: Yup.string()
    .test('ip12', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip13: Yup.string()
    .test('ip13', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip14: Yup.string()
    .test('ip14', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip21: Yup.string()
    .test('ip21', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined) return true;
        else return true;
      }
    }),
  ip22: Yup.string()
    .test('ip22', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip23: Yup.string()
    .test('ip23', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip24: Yup.string()
    .test('ip24', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip31: Yup.string()
    .test('ip31', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined) return true;
        else return true;
      }
    }),
  ip32: Yup.string()
    .test('ip32', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip33: Yup.string()
    .test('ip33', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  ip34: Yup.string()
    .test('ip34', ' ', value => {
      if (value) {
        return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
          !value.startsWith('0') && value <= 255;
      } else {
        if (value === undefined || value === " ") return true;
        else return true;
      }
    }),
  title: Yup.string()
    .required(),
  address: Yup.string()
    .min(10, '')
    .required(),

  iban: Yup.string()
    .required(),

  guildId: Yup.number()
    .required(),
  provinceId: Yup.number()
    .required(),
  subGuildId: Yup.number()
    .required()
});

const Update = () => {
  const { id } = useParams();
  const { readData } = useEntityCrud("Business/GetBusiness?BusinessId=" + id);
  const { addData: addBusinessDocs } = useEntityCrud("Business/setDocument");
  const { addData: addPhotoRequest } = useEntityCrud('PhotoRequest/setPhotoRequests');
  const { addData: addWorkTime } = useEntityCrud("Business/setWorkingTimes");

  const { addData: updateData } = useEntityCrud("Business/UpdateBusiness");
  const navigate = useNavigate();
  const [markerPosCreate, setMarkerPosCreate] = useState({});

  const [ipArray, setIpArray] = useState();

  const { readData: readDataDoc } = useEntityCrud(
    "Business/getDocuments?BusinessId=" + id
  );

  const dd = () => {
    const postedData2 = [];
    formik.values.works
      .filter((item) => item.dayId !== 0)
      .map((item, index) => {
        postedData2.push({
          dayId: item.dayId,
          openTime: item.openTime,
          closeTime: item.closeTime,
          businessId: 618,
        });
      });

    addWorkTime(postedData2).then(({ data }) => {
      console.log(data.result);
    });
  };

  function tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  }

  function timeStringToFloat(time) {
    const str = time;
    const newStr = str.replace(":", "");
    const intTime = parseInt(newStr);
    return intTime;
  }

  function convertTimeToInputValue(time) {
    return moment(time, "HHmm").format("HH:mm");
  }

  useEffect(() => {
    readData().then(({ data }) => {
      debugger
      if (data.status) {
        let person = data.result.person;
          if(person.birthDate){
            let birthday = `${person.birthDate.toString().slice(0,4)}/${person.birthDate.toString().slice(4,6)}/${person.birthDate.toString().slice(6,8)}`
            person.birthDate = birthday;
          }
        formik.setValues({
          ...formik.values,
          ...data.result,
          person,
          birthDate: person.birthDate,
          workingTimes: undefined,
          lang: data.result.lang !== "NaN" ? data.result.lang : 30.5589,
          lat: data.result.lat !== "NaN" ? data.result.lat : 49.1981,
          terminals:
            data.result.terminals && data.result.terminals.length
              ? data.result.terminals
              : [
                {
                  terminalNo: "",
                  acceptorId: "",
                  serialNo: "",
                },
              ],

          works: data.result.workingTimes && data.result.workingTimes.length ? data.result.workingTimes.map((item, index) => ({
            dayId: item.dayId,
            openTime: item.openTime,
            closeTime: item.closeTime,
            businessId: item.businessId,
          })) : formik.initialValues.works
        });
      }




      setMarkerPosCreate({
        lat: data.result.lat !== "NaN" ? data.result.lat : 49.1981,
        lng: data.result.lang !== "NaN" ? data.result.lang : 30.5589,
      });

      const ipArray = data.result.ip.split(",");
      setIpArray(ipArray);

      formik.setFieldValue("ip11", ipArray[0]?.split(".")[0]);
      formik.setFieldValue("ip12", ipArray[0]?.split(".")[1]);
      formik.setFieldValue("ip13", ipArray[0]?.split(".")[2]);
      formik.setFieldValue("ip14", ipArray[0]?.split(".")[3]);

      formik.setFieldValue("ip21", ipArray[1]?.split(".")[0]);
      formik.setFieldValue("ip22", ipArray[1]?.split(".")[1]);
      formik.setFieldValue("ip23", ipArray[1]?.split(".")[2]);
      formik.setFieldValue("ip24", ipArray[1]?.split(".")[3]);

      formik.setFieldValue("ip31", ipArray[2]?.split(".")[0]);
      formik.setFieldValue("ip32", ipArray[2]?.split(".")[1]);
      formik.setFieldValue("ip33", ipArray[2]?.split(".")[2]);
      formik.setFieldValue("ip34", ipArray[2]?.split(".")[3]);

      formik.setFieldValue(
        "logo",
        `https://petromah.sabinarya.com${data.result.logo}`
      );
      formik.setFieldValue(
        "photo1",
        `https://petromah.sabinarya.com${data.result?.photo1}`
      );
      formik.setFieldValue(
        "photo2",
        `https://petromah.sabinarya.com${data.result?.photo2}`
      );
      formik.setFieldValue(
        "photo3",
        `https://petromah.sabinarya.com${data.result?.photo3}`
      );
      formik.setFieldValue(
        "photo4",
        `https://petromah.sabinarya.com${data.result?.photo4}`
      );
      formik.setFieldValue(
        "photo5",
        `https://petromah.sabinarya.com${data.result?.photo5}`
      );
      formik.setFieldValue(
        "photo6",
        `https://petromah.sabinarya.com${data.result?.photo6}`
      );
    });

    readDataDoc().then(({ data }) => {
      if (data.status) {
        formik.setFieldValue(
          "doc1",
          `${data.result?.find((item) => item.docTypeId === 1)?.docPath && data.result?.find((item) => item.docTypeId === 1)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 1)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 1)?.docContent)}`
        );
        formik.setFieldValue(
          "doc2",
          `${data.result?.find((item) => item.docTypeId === 2)?.docPath && data.result?.find((item) => item.docTypeId === 2)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 2)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 2)?.docContent)}`
        );
        formik.setFieldValue(
          "doc3",
          `${data.result?.find((item) => item.docTypeId === 3)?.docPath && data.result?.find((item) => item.docTypeId === 3)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 3)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 3)?.docContent)}`
        );
        formik.setFieldValue(
          "doc4",
          `${data.result?.find((item) => item.docTypeId === 4)?.docPath && data.result?.find((item) => item.docTypeId === 4)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 4)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 4)?.docContent)}`
        );
        formik.setFieldValue(
          "doc5",
          `${data.result?.find((item) => item.docTypeId === 5)?.docPath && data.result?.find((item) => item.docTypeId === 5)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 5)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 5)?.docContent)}`
        );
        formik.setFieldValue(
          "doc6",
          `${data.result?.find((item) => item.docTypeId === 6)?.docPath && data.result?.find((item) => item.docTypeId === 6)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 6)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 6)?.docContent)}`
        );
        formik.setFieldValue(
          "doc7",
          `${data.result?.find((item) => item.docTypeId === 7)?.docPath && data.result?.find((item) => item.docTypeId === 7)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 7)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 7)?.docContent)}`
        );
        formik.setFieldValue(
          "doc8",
          `${data.result?.find((item) => item.docTypeId === 8)?.docPath && data.result?.find((item) => item.docTypeId === 8)?.docPath.includes('pdf') ? data.result?.find((item) => item.docTypeId === 8)?.docPath : ('data:image/jpeg;base64,' + data.result?.find((item) => item.docTypeId === 8)?.docContent)}`
        );
      }
    });
  }, []);

  const onSubmit = (values) => {
    const p1 =
      (values.ip11 || '') + "." + (values.ip12 || '') + "." + (values.ip13 || '') + "." + (values.ip14 || '');
    const p2 =
      (values.ip21 || '') + "." + (values.ip22 || '') + "." + (values.ip23 || '') + "." + (values.ip24 || '');
    const p3 =
      (values.ip31 || '') + "." + (values.ip32 || '') + "." + (values.ip33 || '') + "." + (values.ip34 || '');
    const ip_ = (p1 && (p2 === "undefined.undefined.undefined.undefined") &&
      (p3 === "undefined.undefined.undefined.undefined")) ? (p1) :
      (p1 && p2 && (p3 === "undefined.undefined.undefined.undefined")) ? (p1 + "," + p2) :
        (p1 && p2 && p3) ? (p1 + "," + p2 + "," + p3) :
          (p1 && (p2 === "undefined.undefined.undefined.undefined") && p3) ? (p1 + "," + p3) : ""


    document.getElementById("btn-submit-form").classList.add("btn-loading");
    const postedData = {
      id: id,
      title: values.title,
      address: values.address,
      postalCode: values.postalCode,
      phone: values.phone ? values.phone.replace('-', '') : '',
      iban: values.iban.replaceAll("-", ""),
      onlinePayment: values.onlinePayment,
      walletPayment: values.walletPayment,
      guildId: values.guildId,
      subGuildId: values.subGuildId,
      terminalNo: values.terminals[0].terminalNo,
      acceptorId: values.terminals[0].acceptorId,
      serialNo: values.terminals[0].serialNo,
      website: values.website,
      telegram: values.telegram,
      instagram: values.instagram,
      ip: ip_,
      logo: values.logo ? values.logo.split("base64,")[1] : "",
      lat: parseFloat(formik.values.lat).toFixed(4),
      lang: parseFloat(formik.values.lang).toFixed(4),
      cityId: values.cityId,
      // photo1: values.photo1 ? values.photo1.split("base64,")[1] : "",
      // photo2: values.photo2 ? values.photo2.split("base64,")[1] : "",
      // photo3: values.photo3 ? values.photo3.split("base64,")[1] : "",
      // photo4: values.photo4 ? values.photo4.split("base64,")[1] : "",
      // photo5: values.photo5 ? values.photo5.split("base64,")[1] : "",
      // photo6: values.photo6 ? values.photo6.split("base64,")[1] : "",
      terminals: values.terminals,
      guildTitle: "",
      subGuildtitle: "",
      paymentTypes: values.paymentTypes,
      person: {
          name: values.person?.name,
          lastName: values.person?.lastName,
          nationalCode: values.person?.nationalCode,
          birthDate: values.birthDate,
          cellphone: values.person?.cellphone.replace('-', '')
      },
      countPerBasket: parseInt(values.countPerBasket),
      supportPhones: values.supportPhones
    };
    updateData(postedData)
      .then(({ data }) => {
        debugger

        if (data.status) {
          if(values.logo != null && values.logo != '' && values.logo.includes('base64,')){
            const logoPostedData = {
                photoId: i,
                photoContent: values.logo.split('base64,')[1],
                businessId: id
            }
            addPhotoRequest(logoPostedData);
          }
          for(let i = 1;i < 7;i++){
            if(values[`photo${i}`] != null && values[`photo${i}`] != '' && values[`photo${i}`].includes('base64,')){
                const imagePostedData = {
                    photoId: i,
                    photoContent: values[`photo${i}`].split('base64,')[1],
                    businessId: id
                }
                addPhotoRequest(imagePostedData);
            }
          }
          for (var i = 1; i <= 8; i++) {
            const postedData = {
              docTypeId: i,
              docContent:
                i === i
                  ? formik.values["doc" + i]
                    ? formik.values["doc" + i].split("base64,")[1]
                    : ""
                  : "",
              buisnessId: data.result.id,
            };
            addBusinessDocs(postedData).then(({ data }) => {
            });

          }
          let postedData2 = [];

          formik.values.works
            .map((item, index) => {
              postedData2.push({
                dayId: item.dayId,
                openTime: item.openTime,
                closeTime: item.closeTime,
                businessId: parseInt(id),
              });

            });

          addWorkTime(postedData2).then(({ data }) => {
          });
          toast.success("کسب و کار  با موفقیت ویرایش شد");
          return navigate("/organizations");
        } else data.errors.map((error) => toast.error(error.message));
      })
      .finally(() =>
        document
          .getElementById("btn-submit-form")
          .classList.remove("btn-loading")
      );
  };

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema: validationSchema,
  });



  const handleBack = () => {
    navigate("/organizations", { replace: true });
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <div className="card-title">ویرایش کسب و کار</div>
        <a className="backIconLink" onClick={handleBack}>
          <i className="fa fa-arrow-left" title="بازگشت"></i>
        </a>
      </div>
      <div className="card-body">
        <Form
          id={id}
          formik={formik}
          dd={dd}
          isEditMode={true}
          markerPosCreate={markerPosCreate}
          setMarkerPosCreate={setMarkerPosCreate}
        />
      </div>
    </div>
  );
};

export default Update;
